import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { RequestsService } from '../services/requests.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import { UserService } from '../../../user/services/user.service';
import { DependentService } from '../../../user/services/dependent.service';
import { Dependent } from '../../../user/models/user-profile.model';

@Component({
  selector: 'app-segunda-opinion',
  imports: [CommonModule, FormsModule, MatIconModule, MatRadioModule, MatFormFieldModule, MatInputModule],
  templateUrl: './segunda-opinion.component.html',
  styleUrl: './segunda-opinion.component.scss'
})
export class SegundaOpinionComponent {
  selectedPatient = 'titular';
  selectedDependent = '';
  postalCode = '';
  showConsultorios = false;
  nameOwner: string = '';
  phoneOwner: string = '';
  keyOwner: string = '';
  contactoDeTelefono: string = '0';
  dependent: Dependent[] = [];
  userProfile: any;


  consultorios = [
    { tipo: 'building', nombre: 'Consultorio especializado dos', direccion: 'Calle del Olivo, 121, Int. 3, Colonia Cocos.' },
    { tipo: 'doctor', nombre: 'Consultorio Dr. Gómez', direccion: 'Blvd. Adolfo López Mateos, 56, Benito Juárez, CDMX.' },
    { tipo: 'building', nombre: 'Especialidades médicas Sta. María', direccion: 'Calzada de las Acacias, 43, Altamirano.' },
    { tipo: 'building', nombre: 'Clínica Salud Integral', direccion: 'Avenida del Parque, 22, San José del Cabo.' },
    { tipo: 'doctor', nombre: 'Consultorio Dental Dr. Pérez', direccion: 'Calle de la Paz, 73, Colonia Centro.' },
    { tipo: 'building', nombre: 'Hospital General de Especialidades', direccion: 'Paseo de la Reforma, 125, CDMX.' }
  ];

  constructor(
    private router: Router, 
    private requestServ: RequestsService, 
    private loader: LoaderService, 
    private route: ActivatedRoute,
    private userService: UserService,
    private dependentService: DependentService
  ) {
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObj = JSON.parse(userData);
      this.nameOwner = userObj.name || '';
      this.phoneOwner = userObj.phone || '';
      this.keyOwner = userObj.memberships || '';
    }
    this.getServiceContact();
    this.getDetailUser();
    
    this.dependentService.direccionActualizada$.subscribe(() => {
      this.getDetailUser();
    });
  }

  ngOnInit() {
    this.getDetailUser();
  }

  private getServiceContact(): void {
    try {
      const contacts = JSON.parse(localStorage.getItem('servicesContact') || '[]');
      // Leer desde params.nombre
      const clSubServicio = parseInt(this.route.snapshot.params['nombre']);
      const serviceContact = contacts.find((c: any) => c.clSubServicio === clSubServicio);
      this.contactoDeTelefono = serviceContact?.phone || '0';
    } catch {
      this.contactoDeTelefono = '0';
    }
  }

  getDetailUser() {
    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          this.userProfile = res;
          this.dependent = res.dependents;
        },
        error: (err) => console.error('Error al obtener perfil', err)
      });
    }
  }

  isSelected(value: string): boolean {
    return this.selectedPatient === value;
  }

  addNewDependent() {
    this.router.navigate(['add-dependiente'], { queryParams: { returnUrl: this.router.url } });
  }

  onSolicitar() {
    console.log('Solicitar segunda opinión');
    console.log('Paciente:', this.selectedPatient);
    console.log('Dependiente:', this.selectedDependent);
    console.log('Código postal:', this.postalCode);
    this.showConsultorios = true;
  }

  onCambiarCodigoPostal() {
    console.log('Cambiar código postal');
    // Lógica para cambiar código postal
  }

  onSeleccionarConsultorio(consultorio: any) {
    console.log('Consultorio seleccionado:', consultorio);
    // Lógica para seleccionar consultorio
  }

  onSolicitarConsultorio() {
    console.log('Solicitar consultorio');
    this.generateExpediente();
  }

  generateExpediente() {
    const solicitudData = localStorage.getItem('solicitudData');
    let servicio;
    
    if (solicitudData) {
      servicio = JSON.parse(solicitudData).servicio;
    } else {
      const params = this.route.snapshot.queryParams;
      servicio = {
        clServicio: params['clServicio'] || 4,
        clSubservicio: params['clSubServicio'] || 376,
        dsServicio: params['dsServicio'] || 'Asistencia Médica',
        dsSubServicio: params['dsSubServicio'] || 'Segunda Opinion'
      };
    }
    
    this.loader.show();
    
    const selectedName = this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient;
    const { firstName, lastName, secondLastName } = this.splitFullName(selectedName);
    const { firstName: ownerFirstName, lastName: ownerLastName, secondLastName: ownerSecondLastName } = this.splitFullName(this.nameOwner);
    
    const accountData = localStorage.getItem('account');
    const accountId = accountData ? JSON.parse(accountData) : 536;
    
    const payload = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        serviceId: servicio.clServicio,
        subServiceId: servicio.clSubservicio.toString(),
        hasAssistance: false,
        key: this.keyOwner,
        areaCode1: '044',
        phone1: this.phoneOwner,
        stateCode: '',
        municipalityCode: '',
        statusId: 0,
        accountId: accountId,
        appUserId: 1,
        countryId: 115,
        contactTypeId: 15,
        serviceTypeId: 1,
        sendCharge: false,
        hasAppointment: false,
        isRelevant: false,
        gender: 1,
        isOk: true,
        hasQuotation: false,
        isSise2: true,
        serviceReceptionId: 10,
        personId: 1,
        username: firstName,
        paternalSurname: lastName,
        userSecondLastName: secondLastName,
        contactName: selectedName,
        userFirstNamePf: ownerFirstName,
        userLastNamePf: ownerLastName,
        userSecondLastNamePf: ownerSecondLastName,
        ourUser: this.nameOwner,
        externalCabRepName: 'API CLIENTES',
        folio: crypto.randomUUID(),
        longitude: '', // Vacío como solicitaste
        latitude: '', // Vacío como solicitaste
        incidentDescription: `Segunda opinión médica - CP: ${this.postalCode}`,
        clRecepcionServicio: 10
      }
    };

    this.requestServ.sendSegundaOpinionRequest(payload).subscribe({
      next: (res) => {
        this.loader.hide();
        console.log('Expediente generado:', res);
        
        const expediente = res?.response?.id || res?.data?.clExpediente || res?.clExpediente;
        
        const assistanceData = {
          clave: res.response.clave || '',
          clexpediente: expediente,
          nuestrousuario: res.response.nuestrousuario || this.nameOwner,
          clcuenta: res.response.clcuenta || '',
          nombre: 'SEGUNDA OPINIÓN',
          clservicio: res.response.clservicio || servicio.clServicio,
          dsservicio: servicio.dsServicio || 'Segunda Opinión Médica',
          clsubservicio: res.response.clsubservicio || servicio.clSubservicio,
          dssubservicio: servicio.dsSubServicio || 'Segunda Opinión',
          clestatus: res.response.clestatus || '0',
          dsestatus: 'Abierto',
          fecharegistro: res.response.fecharegistro || new Date().toISOString()
        };
        
        if (solicitudData) {
          localStorage.removeItem('solicitudData');
        }
        
        const navigationExtras: NavigationExtras = {
          state: assistanceData,
          queryParams: assistanceData
        };
        
        this.router.navigate(['/solicitud/detalle/', expediente], navigationExtras).then(() => {
          setTimeout(() => {
            this.goToCall();
          }, 1000);
        });
      },
      error: (err) => {
        this.loader.hide();
        console.error('Error al generar expediente:', err);
      }
    });
  }

  private splitFullName(fullName: string) {
    const parts = fullName.trim().split(/\s+/).filter(p => p);
    if (parts.length <= 1) return { firstName: parts[0] || '', lastName: '', secondLastName: '' };
    if (parts.length === 2) return { firstName: parts[0], lastName: parts[1], secondLastName: '' };
    if (parts.length === 3) return { firstName: parts[0], lastName: parts[1], secondLastName: parts[2] };
    // Para nombres con 4 o más partes, asumir que los primeros 2 son nombres y los últimos 2 son apellidos
    return {
      firstName: parts.slice(0, 2).join(' '),
      lastName: parts[parts.length - 2],
      secondLastName: parts[parts.length - 1]
    };
  }

  goToCall() {
    if (this.contactoDeTelefono && this.contactoDeTelefono !== '0') {
      window.open(`tel:${this.contactoDeTelefono}`, '_self');
    }
  }
}